/**
 *
 * Slider
 *
 *
 */


jQuery(document).ready(function(){

    var SliderUI = function(el){

        this.$el = jQuery( el );
        this.$slider_wrap = this.$el.find( '.slider-wrap' );

        this.init();
    };

    SliderUI.prototype.init = function(){

        if (!Foundation.MediaQuery.atLeast('medium')) {

            return;
        }

        this.$slider_wrap.slick({
            arrows: false,
            centerMode: true,
            padding: '15px',
            centerPadding: '0px',
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            cssEase: 'linear',
            easing: 'linear',
            autoplay: false,
            draggable: false,

            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });

    };
});

